import { toast } from 'react-toastify';

import { type IResponseError } from '@/utils/types/forms';

import { errorMessageFormatter } from '@/_helpers/errorMessageFormatter';
import { type getDictionary } from '@/_i18n/dictionaries';

export const ToastErrors = (errors: IResponseError[], dict: Awaited<ReturnType<typeof getDictionary>>) => {
  if (errors.length === 1) {
    toast.error(
      <span>
        {errors[0]?.property ? <strong>{errors[0].property}: </strong> : null}
        {errorMessageFormatter(errors[0], dict)}
      </span>,
    );
  } else if (errors.length > 1) {
    toast.error(
      <ul>
        {errors.map((error, index) => (
          <li key={index}>
            {error?.property ? <strong>{error.property}: </strong> : null}
            {errorMessageFormatter(error, dict)}
          </li>
        ))}
      </ul>,
    );
  }

  return;
};
